import {Box, Skeleton} from '@mantine/core';
import type {FC} from 'react';
import type {InputTypes} from '../../../../../core/entities/reports/constants';
import {convertRadioTypeAnswer} from '../../../usecase/convertRadioTypeAnswer';

type Question = {
  label: string;
  value: string;
  inputType?: InputTypes;
};

type Props = {
  label: string;
  questionList: Question[];
  isHideLabel?: boolean;
};

export const PcQuestionList: FC<Props> = (props) => {
  return (
    <Box className="bg-white rounded-t-[4px] rounded-b-[12px] text-black-1 mt-4 px-8 pc:mt-8 pc:p-24 pc:text-md">
      {props.questionList.map((item, index) => {
        return (
          <div
            key={`${props.label}-${index}`}
            className="flex flex-col border-b-[1px] border-line mt-4 p-8 pc:mt-8 pc:flex-row"
          >
            <div className="font-bold text-black-1 pc:w-1/4">{item.label}</div>
            {props.isHideLabel ? (
              <Skeleton height={20} animate={false} />
            ) : (
              <div className="mt-8 whitespace-pre-wrap text-black-1 pc:w-3/4 pc:pl-20">
                {convertRadioTypeAnswer(item.value, item.inputType)}
              </div>
            )}
          </div>
        );
      })}
    </Box>
  );
};
